module.exports = __webpack_public_path__ + "assets/joy.19c798e87ea65ff0f802d836785d92d2f966a208786911ed34c59f66ff1cf27c.png";